module.exports = __webpack_public_path__ + "static/img/login_logo.7549e512.png";